/* SET STATE */
export const SET_STATE_NORM = "SET_STATE_NORM"

/* NORMS */
export const GET_NORMS = "GET_NORMS"
export const GET_NORMS_SUCCESS = "GET_NORMS_SUCCESS"
export const GET_NORMS_FAIL = "GET_NORMS_FAIL"

/* NORM */
export const GET_NORM = "GET_NORM"
export const GET_NORM_SUCCESS = "GET_NORM_SUCCESS"
export const GET_NORM_FAIL = "GET_NORM_FAIL"

/**
 * ADD NORM
 */
 export const ADD_NEW_NORM = "ADD_NEW_NORM"
 export const ADD_NORM_SUCCESS = "ADD_NORM_SUCCESS"
 export const ADD_NORM_FAIL = "ADD_NORM_FAIL"

 /**
 * UPDATE NORM
 */
export const UPDATE_NORM = "UPDATE_NORM"
export const UPDATE_NORM_STATUS = "UPDATE_NORM_STATUS"
export const UPDATE_NORM_SUCCESS = "UPDATE_NORM_SUCCESS"
export const UPDATE_NORM_FAIL = "UPDATE_NORM_FAIL"

/**
 * DELETE NORM
 */
export const DELETE_NORM = "DELETE_NORM"
export const DELETE_NORM_SUCCESS = "DELETE_NORM_SUCCESS"
export const DELETE_NORM_FAIL = "DELETE_NORM_FAIL"
